import React, { useEffect, useState, useRef } from 'react';
import moment from 'moment';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import Comment from './Comment';
import ButtonAction from './ButtonAction';
import { appendMoreReplyCommentData, postReplyComment } from './actions';
import {
  makeSelectLoadingReplyAppend,
  selectComments,
  makeSelectLoadingSubmit,
} from './selectors';
import Form from './form';
import {
  makeSelectProfile,
  makeSelectIsAuthenticated,
} from '../AuthProvider/selectors';
import LoadingSpinner from '~/components/loading-spinner/LoadingSpinner';
import Link from '~/components/I18nLink';
import IconSendComment from '~/components/svg/send-comment.svg';
import themeVariables from '~/shared/themeVariables';

const Index = ({
  commentsData,
  isOpenFormReply,
  idReplyClick,
  appendMoreReplyCommentData,
  loadingMoreReplyComment,
  setIdReplyClick,
  isAuthenticated,
  profile,
  postReplyComment,
  commentID,
  loadingSubmit,
  comment,
  t,
}) => {
  const formik = useRef();
  const comment_id = collection?.[0]?.comment_id || commentID;
  const [isLoadingReply, setIsLoadingReply] = useState(false);
  const [dataReply, setDataReply] = useState({
    collection: [],
    has_next: false,
  });

  const { collection = [], has_next = false } = dataReply;
  const [countText, setCountText] = useState(0);

  useEffect(() => {
    if (comment?.dataReply) {
      setDataReply(comment.dataReply);
    } else {
      setDataReply({
        collection: [],
        has_next: false,
      });
    }
    if (!loadingSubmit) {
      formik.current?.resetForm();
    }
  }, [comment?.dataReply, loadingSubmit, formik]);

  useEffect(() => {
    if (loadingMoreReplyComment && idReplyClick === comment_id) {
      setIsLoadingReply(true);
    } else {
      setIsLoadingReply(false);
    }
  }, [loadingMoreReplyComment, idReplyClick, collection]);

  const onClickSeeMore = () => {
    if (commentsData?.comments?.length > 0) {
      const { comments } = commentsData;
      const dataCommentHasReply = comments.find((data) => {
        return data.id === comment_id;
      });
      const { dataReply } = dataCommentHasReply;
      if (dataReply?.has_next) {
        setIdReplyClick(comment_id);
        appendMoreReplyCommentData({
          page: dataReply.page + 1 || 1,
          comment_id: comment_id,
          data_id: commentsData?.object_id,
        });
      }
    }
  };
  const validate = (values) => {
    let errors = {};
    if (!values.text) {
      errors.text = 'Required';
    }
    return errors;
  };
  const validateText = (e) => {
    setCountText(e.target.value.length);
  };
  const onSummit = async (values, action) => {
    if (values && isAuthenticated) {
      await postReplyComment({
        user_id: profile.id,
        text: values,
        comment_id: comment_id,
        data_id: commentsData?.object_id,
      });
    }
    // action.setSubmitting(true);
    // setTimeout(() => {
    //   console.log(JSON.stringify(values, null, 2));
    //   this.props.postComment({ text: values.text });
    //   action.setSubmitting(false);
    //   action.resetForm();
    // }, 4000);
  };
  const handleHiddenInforEmail = (email) => {
    const array = email.split('@');
    const lengthData = array[0].length;
    const start = array[0].slice(0, lengthData / 4);
    const end = array[0].slice((lengthData / 4) * 3 + 1, lengthData);
    return start + '*****' + end + array[1];
  };
  if (!isAuthenticated && collection?.length <= 0) return null;
  return (
    <div className="container-list-reply-comment">
      {isAuthenticated && (
        <div className="container-form-reply">
          <div className="media-heading">
            <div className="name-header">{profile.nickname}</div>
          </div>
          <div className="content-comment">
            <Formik
              initialValues={{ text: '' }}
              validate={validate}
              onSubmit={onSummit}
              ref={formik}
            >
              {({
                values,
                errors,
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue,
              }) => (
                <form
                  className="container-form-comment"
                  onSubmit={handleSubmit}
                >
                  <div className="container-input-form">
                    <div className="container-input">
                      <input
                        name="text"
                        className={`input-comment ${
                          errors.text ? 'error-form' : ''
                        } ${loadingSubmit ? 'loadingSubmit' : ''}`}
                        placeholder={t('add_your_comment')}
                        onChange={(e) => {
                          // handleChange();
                          validateText(e);
                          setFieldValue('text', e.target.value);
                        }}
                        onBlur={handleBlur}
                        value={values.text}
                        disabled={loadingSubmit}
                      />
                      <div
                        className={`container-icon-send ${
                          countText > 0 ? 'active-submit' : ''
                        }`}
                        onClick={handleSubmit}
                      >
                        <IconSendComment
                          color={
                            countText > 0 ? themeVariables.color.primary : ''
                          }
                        />
                      </div>
                    </div>
                  </div>
                </form>
              )}
            </Formik>
          </div>
        </div>
      )}
      {collection?.length > 0 &&
        collection?.map((data, index) => {
          const name = data?.name || '';
          let email = handleHiddenInforEmail(data?.email || '');
          return (
            <div className="container-data" key={index}>
              <div className="media-heading">
                <div className="name-header">
                  {data?.is_creator ? (
                    <Link href={`/creator-profile/${data.user_id}`}>
                      {name || email}
                    </Link>
                  ) : (
                    name || email
                  )}
                </div>
                <div className="date-comment">
                  {data?.created_at
                    ? moment.unix(data?.created_at).fromNow()
                    : ''}
                </div>
              </div>
              <div className="content-comment">{data?.text}</div>
            </div>
          );
        })}
      {isLoadingReply && <LoadingSpinner style={{ padding: '40px 0' }} />}
      {has_next && <ButtonAction onClickSeeMore={onClickSeeMore} />}

      <style jsx>{`
        .container-list-reply-comment {
          width: 100%;
          background: #f8f9fa;
          border-radius: 4px;
          padding: 8px 16px;
          display: flex;
          flex-direction: column;
          gap: 24px;
        }
        .container-data {
          border-left: 2px solid #7a7a7a;
          padding-left: 16px;
        }
        .media-heading {
          display: flex;
          gap: 24px;
        }
        .name-header {
          font-weight: 700;
          font-size: 16px;
          line-height: 28px;
          color: #3a4ed7;
        }
        .date-comment {
          display: flex;
          flex-direction: column;
          justify-content: center;
          space-between: center;
          font-weight: 500;
          font-size: 16px;
          color: #7a7a7a;
        }
      `}</style>
      <style jsx>{`
        .container-form-comment {
          height: 56px;
          display: flex;
          gap: 16px;
        }
        .container-input-form {
          width: 100%;
          height: 100%;
          display: flex;
        }
        .container-input {
          width: 100%;
          height: 100%;
          background-color: #f8f9fa;
          background-image: none;
          display: flex;
        }
        .container-icon-send {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding-right: 12px;
        }
        .input-comment {
          width: 100%;
          height: 100%;
          padding: 6px 12px;
          font-size: 14px;
          color: #555;
          background-color: #f8f9fa;
          background-image: none;
          border: none;
        }
        .input-comment.loadingSubmit {
          color: grey;
        }
      `}</style>
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  commentsData: selectComments,
  loadingMoreReplyComment: makeSelectLoadingReplyAppend(),
  isAuthenticated: makeSelectIsAuthenticated(),
  profile: makeSelectProfile(),
  loadingSubmit: makeSelectLoadingSubmit(),
});

const mapDispatchToProps = (dispatch) => ({
  appendMoreReplyCommentData: (params) =>
    dispatch(appendMoreReplyCommentData(params)),
  postReplyComment: (params) => dispatch(postReplyComment(params)),
});

const Connector = connect(mapStateToProps, mapDispatchToProps)(Index);

export default Connector;
